{
  "loanList": {
    "overview": {
      "title": "Overview"
    },
    "table": {
      "title": "Loans Table",
      "search": "Search",
      "filter": "Filter",
      "clearAll": "Clear all",
      "columns": {
        "loanNumber": "Loan #",
        "client": "Client",
        "state": "State",
        "city": "City",
        "propertyAddress": "Property Address",
        "zipCode": "Zip Code",
        "borrowerFirstName": "Borrower First Name",
        "borrowerLastName": "Last Name",
        "coborrowerFirstName": "Coborrower First Name",
        "coborrowerLastName": "Last Name",
        "loanType": "Loan Type",
        "originalAmount": "Original Amount"
      },
      "emptyState": {
        "title": "No loans found.",
        "descriptionWithFilters": "Try adjusting your filters or search criteria.",
        "descriptionNoData": "There are no loans to display at this time."
      }
    }
  }
}
